// extracted by mini-css-extract-plugin
export default {"root":"root__Vactc","price":"price__50gjA","zipLabel":"zipLabel__IgBMG"};